export default __webpack_public_path__ + "static/media/white_unicorn.cca2fd0a.png";